// extracted by mini-css-extract-plugin
export default {"container":"YR-z","topReviewHeading":"ZR-z","criticalReview":"_R-z","favorableReview":"aS-z","vsSeparator":"bS-z"};